document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.mySwiper');
  if (!swiperEl || swiperEl.swiper) return;

  // Проверяем, что Swiper загружен (CDN)
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper не загружен');
    return;
  }

  const paginationEl = swiperEl.querySelector('.swiper-pagination');
  const slidesCount  = swiperEl.querySelectorAll('.swiper-slide').length;
  const enableLoop   = slidesCount >= 4;

  const instance = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: false,
    loop: enableLoop,
    speed: 500,
    grabCursor: true,
    watchSlidesProgress: true,

    pagination: {
      el: paginationEl,
      clickable: true,
      dynamicBullets: false,
      type: 'bullets'
    },

    keyboard: {
      enabled: true,
      onlyInViewport: true
    },

    breakpoints: {
      320:  { spaceBetween: 15 },
      768:  { spaceBetween: 20 },
      1200: { spaceBetween: 30 }
    }
  });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (instance && instance.update) instance.update();
    }, 250);
  });
});
